module.exports = __webpack_public_path__ + "img/banner-home-mobile@3x.b7493ad4.png";